import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import MobileSelectField from "./mobile/mobile-select-field";
import { useIsMobile } from "../hooks/use-is-mobile";

export interface SelectOption {
  label: string;
  value: string;
  description?: string;
}

export interface SelectInputProps {
  value: string;
  options: SelectOption[];
  placeholder?: string;
  onChange: (value: string) => void;
  className?: string;
  disabled?: boolean;
}

const SelectInput: React.FC<SelectInputProps> = ({
  value,
  options,
  placeholder = "Select",
  onChange,
  className,
  disabled = false,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileSelectField
        value={value}
        options={options}
        placeholder={placeholder}
        onChange={onChange}
        disabled={disabled}
      />
    );
  }

  return (
    <Select onValueChange={onChange} value={value} disabled={disabled}>
      <SelectTrigger
        className={`${className?.includes("w-full") ? "w-full" : "w-[150px]"} h-9 bg-white border border-input ring-offset-background focus:outline-none focus:ring-1 focus:ring-primary-500 focus:ring-offset-0 tracking-[0em] ${className ?? ""}`}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options
          .filter((option) => option.value != null && option.value !== "")
          .map((option) => (
            <SelectItem
              key={option.value}
              value={option.value}
              className="hover:bg-gray-100 data-[state=checked]:bg-primary-100 data-[state=checked]:text-primary-800"
            >
              {option.label}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
};

export default SelectInput;
